import { BasicInput } from '../withFormProps';
import React, { ChangeEvent, useCallback } from 'react';
import { useField } from '@kizi/comparator-core';

export type FirstNameProps = React.ComponentPropsWithRef<typeof BasicInput> & {
  initialsFieldName: string;
  name: string;
};

export const FirstName: React.FC<FirstNameProps> = ({
  initialsFieldName,
  name,
}) => {
  const firstnameField = useField(name);
  const initialsField = useField('*.' + initialsFieldName);
  if (!firstnameField || !initialsField) return null;
  const {
    onChange,
    value,
    errors,
    label,
    name: fieldNameWithoutFormName,
  } = firstnameField;
  const error = errors?.join('. ');
  const onChangeWrapper = useCallback(
    (e: ChangeEvent<any>) => {
      if (initialsField.onChange && onChange) {
        initialsField.onChange({
          type: 'CHANGE',
          target: {
            name: initialsField.name,
            value: (e.target.value as string).charAt(0),
          },
        });
        onChange({
          type: 'CHANGE',
          target: { name: fieldNameWithoutFormName, value: e.target.value },
        });
      }
    },
    [firstnameField, name, initialsField.name]
  );
  return (
    <BasicInput
      name={fieldNameWithoutFormName}
      _label={label}
      _error={error}
      onChange={onChangeWrapper}
      value={value}
    />
  );
};
